<template>
	<div class="gb-layer-chart" v-bind:style="styleLayoutChart">
		<GBChartContent 
			v-for="item in items" 
			v-bind:key="item.codeWithType"
			v-bind:item="item" 
			v-bind:isEditable="isEditable"
			v-bind:ghost_schedule="ghost_schedule"
			v-on:hscroll-stop="onHScrollStop"
			v-on:bar-move-start="barMoveStart"
			v-on:bar-stretch-start="barStretchStart"
			v-on:bar-move-break="barMoveBreak"
			v-on:chart-row-mouse-move="onMouseMoveChartRow"
			v-on:progress-rate-setting="progressRateSetting"
			v-on:request-ghost-schedule="onRequestGhostSchedule" />
	</div>
</template>
<script>
import GBChartContent from './GBChartContent';

export default {
	name:"GBLayerChart",
	props: [
		"items", 
		"isEditable",
		"ghost_schedule",
	],
	components: {
		GBChartContent,
	},
	methods: {
		barMoveStart: function(e) {
			this.$emit('bar-move-start', e);
		},
		barStretchStart: function(e) {
			this.$emit('bar-stretch-start', e);
		},
		barMoveBreak: function() {
			this.$emit('bar-move-break');
		},
		onMouseMoveChartRow: function(e) {
			this.$emit('chart-row-mouse-move', e);
		},
		onHScrollStop: function(e) {
			this.$emit('hscroll-stop', e);
		},
		progressRateSetting: function(e) {
			this.$emit("progress-rate-setting", e);
		},
		onRequestGhostSchedule: function(e) {
			this.$emit("request-ghost-schedule", e);
		},
	},
	computed: {
		styleLayoutChart: function() {
			return {
				width: this.$store.getters.innerWidth + 'px',
				height: 100 + '%',
			};
		},
	},
}
</script>
<style>
	.gb-layer-chart {
		position: relative;
		width: 100%;
		z-index: 100;
	}
</style>
